import { render, staticRenderFns } from "./join_2.vue?vue&type=template&id=dcffefa6&scoped=true&"
import script from "./join_2.vue?vue&type=script&lang=js&"
export * from "./join_2.vue?vue&type=script&lang=js&"
import style0 from "./join_2.vue?vue&type=style&index=0&id=dcffefa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcffefa6",
  null
  
)

export default component.exports